import { combineReducers } from 'redux'
import SubleaseReducer from '../../Sublease/shared/store/sublease'
import NewOwnersReducer from './newOwners'
import newOwnerDetailsReducer from './newOwnerDetails'

const taskReducer = combineReducers({
  sublease: SubleaseReducer,
  newOwners: NewOwnersReducer,
  newOwnersDetails: newOwnerDetailsReducer,
})

export default taskReducer
